import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function simpleQueryPageFunc(data) {
  return request({
    url: URL.warehouseIn.simpleQueryPage,
    method: 'post',
    data
  })
}

export function advancedQueryFunc(data) {
  return request({
    url: URL.warehouseIn.advancedQuery,
    method: 'post',
    data
  })
}

// 前置仓-仓库查询
export function preWarehouseAdvancedQuery(data) {
  return request({
    url: URL.warehouseIn.preWarehouseAdvancedQuery,
    method: 'post',
    data
  })
}

// 拣货单-高级查询
export function pickingAdvancedQuery(data) {
  return request({
    url: URL.warehouseIn.pickingAdvancedQuery,
    method: 'post',
    data
  })
}

// 拣货单-查询明细
export function pickingOrderDetail(data) {
  return request({
    url: URL.warehouseIn.pickingOrderDetail,
    method: 'post',
    data
  })
}

// 前置仓-拣货完成&取消拣货完成
export function pickingOrderStatus(data) {
  return request({
    url: URL.warehouseIn.pickingOrderStatus,
    method: 'post',
    data
  })
}

// 前置仓-生成拣货单
export function savePickingOrder(data) {
  return request({
    url: URL.warehouseIn.savePickingOrder,
    method: 'post',
    data
  })
}

// 前置仓-出仓确认
export function outboundConfirm(data) {
  return request({
    url: URL.warehouseIn.outboundConfirm,
    method: 'post',
    data
  })
}
// 前置仓-取消确认出仓
export function outboundCancel(data) {
  return request({
    url: URL.warehouseIn.outboundCancel,
    method: 'post',
    data
  })
}

// 前置仓-删除拣货单
export function deletePickingOrder(data) {
  return request({
    url: URL.warehouseIn.deletePickingOrder,
    method: 'post',
    data
  })
}

// 前置仓-拣货单移除文件
export function removeFileForPickingOrder(data) {
  return request({
    url: URL.warehouseIn.removeFileForPickingOrder,
    method: 'post',
    data
  })
}

// 删除
export function removeFunc(params) {
  return request({
    url: URL.warehouseIn.delWarehouseInForAe,
    method: 'delete',
    params: params
  })
}

// 批量删除
export function batchRemoveFunc(data) {
  return request({
    url: URL.warehouseIn.batchRemove,
    method: 'post',
    data
  })
}

// 获取仓储
export function detail(params) {
  return request({
    url: URL.warehouseIn.detailPage,
    method: 'get',
    params
  })
}
// 获取仓储费用
export function warehouseInCharge(data) {
  return request({
    url: URL.warehouseIn.warehouseInChargeUrl,
    method: 'post',
    data
  })
}

// 根据流水号查询仓储
export function queryDataBySerialNumberFunc(data) {
  return request({
    url: URL.warehouseIn.queryDataBySerialNumberUrl,
    method: 'post',
    data
  })
}

// 根据流水号查询仓储
export function updateWarehouseInFunc(data) {
  return request({
    url: URL.warehouseIn.updateWarehouseInUrl,
    method: 'post',
    data
  })
}
// 出仓指令/取消
export function outboundOrderFunc(data) {
  return request({
    url: URL.warehouseIn.outboundOrderUrl,
    method: 'post',
    data
  })
}

// 保存仓储
export function saveFunc(data) {
  return request({
    url: URL.warehouseIn.savePage,
    method: 'post',
    data
  })
}

// 更新仓储详情版纸号
export function saveWarehouseForPalletNumberFunc(data) {
  return request({
    url: URL.warehouseIn.saveWarehouseForPalletNumberUrl,
    method: 'post',
    data
  })
}

// 导出全部
export function exportAllToExcelFunc(data) {
  return request({
    url: URL.warehouseIn.exportAllToExcel,
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 根据进仓编号查询业务
export function queryJobByWarehouseNoFunc(data) {
  return request({
    url: URL.warehouseIn.queryJobByWarehouseNo,
    method: 'post',
    data
  })
}

// 根据进仓编号查询业务
export function getJobDetailFunc(params) {
  return request({
    url: URL.warehouseIn.getJobDetailByKey,
    method: 'get',
    params
  })
}

// 根据进仓编号获取业务-国内仓用
export function getFbaJobByWarehouseNo(data) {
  return request({
    url: URL.warehouseIn.getFbaJobByWarehouseNo,
    method: 'post',
    data
  })
}

// 根据业务标识获取货物明细
export function getFbaJobDetailByKey(params) {
  return request({
    url: URL.warehouseIn.getFbaJobDetailByKey,
    method: 'get',
    params
  })
}

// 简单查询，高级查询公用
export function fbaQuery(data) {
  return request({
    url: URL.warehouseIn.fbaQuery,
    method: 'post',
    data
  })
}

// 获取仓储
export function fbaDetail(params) {
  return request({
    url: URL.warehouseIn.fbaDetailPage,
    method: 'get',
    params
  })
}

// 保存仓储
export function fbaSaveFunc(data) {
  return request({
    url: URL.warehouseIn.fbaSavePage,
    method: 'post',
    data
  })
}

// 修改仓储部分字段【退件、核单】
export function updateFields(data) {
  return request({
    url: URL.warehouseIn.updateFields,
    method: 'post',
    data
  })
}

// 海运头程核单
export function fbaSeaExportChecklist(data) {
  return request({
    url: URL.warehouseIn.fbaSeaExportChecklist,
    method: 'post',
    data
  })
}

// 加载warehouseIn的关联实体信息
export function loadWarehouseInRelated(params) {
  return request({
    url: URL.warehouseIn.loadWarehouseInRelated,
    method: 'get',
    params
  })
}

// 加载FBA海出货物明细的关联实体信息
export function loadFbaExportWarehouseInRelated(data) {
  return request({
    url: URL.warehouseIn.loadFbaExportWarehouseInRelated,
    method: 'post',
    data
  })
}

// 保存前验证仓储编号是否已存在
export function checkWarehouseNo(data) {
  return request({
    url: URL.warehouseIn.checkWarehouseNo,
    method: 'post',
    data
  })
}

// 简单查询，高级查询公用-国外仓
export function fbaQueryOversea(data) {
  return request({
    url: URL.warehouseIn.fbaQueryOversea,
    method: 'post',
    data
  })
}

// 查询业务信息
export function queryJobByKey(data) {
  return request({
    url: URL.warehouseIn.queryJobByKey,
    method: 'post',
    data
  })
}
